<template>
  <v-navigation-drawer app v-model="drawerV">
    <v-list>
      <v-list-item class="justify-center">
        <v-list-item-avatar>
          <v-img
            src="https://png.pngtree.com/png-vector/20210615/ourlarge/pngtree-fifa-world-cup-golden-trophy-champion-league-png-image_3452588.jpg"
            alt="Coupe du monde"
            height="50px"
            width="100px"
          />
        </v-list-item-avatar>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-list nav dense class="mt-1">
      <v-list-item-group v-model="selectedItem" color="#76008d">
        <v-list-item v-for="(item, i) in items" :key="i" :to="item.to">
          <v-list-item-icon>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title v-text="item.text"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-divider></v-divider>
    <div class="mt-3 text-center">
      <span class="font-weight-light">v0.1</span>
    </div>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "SidebarComponent",
  props: ["drawer"],
  data() {
    return {
      drawerV: this.drawer,
      selectedItem: 0,
      items: [
        {
          text: "Accueil",
          icon: "mdi-home",
          to: "/",
        },
        {
          text: "Confrontations",
          icon: "mdi-tournament",
          to: "/confrontation",
        },
        {
          text: "Coupes",
          icon: "mdi-trophy",
          to: "/coupe",
        },
        {
          text: "Pays",
          icon: "mdi-flag",
          to: "/pays",
        },
        {
          text: "Statistiques",
          icon: "mdi-chart-bar",
          to: "/statistiques",
        },
      ],
      admins: [
        ["Management", "mdi-account-multiple-outline"],
        ["Settings", "mdi-cog-outline"],
      ],
    };
  },

  watch: {
    drawer: function () {
      this.drawerV = !this.drawerV;
    },
  },
  mounted() {},
};
</script>

<style scoped>
v-list-item.active {
  color: red;
}
</style>
